module.exports = __webpack_public_path__ + "static/media/logoHeader.81f0bd42.svg";